import styles from "./Box.module.scss";

export function AlignCenter({ children }) {
    return <span className={styles.alignCenter}>{children}</span>;
  }

export  function AlignRight({ children }) {
    return <span className={styles.alignRight}>{children}</span>;
  }

export  function AlignLeft({ children }) {
    return <span className={styles.alignLeft}>{children}</span>;
  }

export  function InputArea({ children }) {
    return <span  className={styles.inputArea}>{children}</span>;
  }

export function InputAreaDupla({ children }) {
    return <span className={styles.inputAreaDupla}>{children}</span>;
  }
